<template>
  <div :id="type">
    <div id="loading-text"></div><br>
    <div id="page_progress">
      <div id="progress_bar"></div>
    </div>
    <div id="pattern_div"></div>
    <img class="spinning-cog" src="../../assets/mondoconnex-logo-icon@2x.png" style="width: 100px;height: 100px;">
  </div>
</template>
<script>
  export default {
    props: {
      type: ''
    }
  }
</script>
<style>
  #full-page-loading{
    position: fixed;
    width:100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9999999999;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    background-color: black;
    flex-direction: column;
    display: none;
  }
  #full-page-loading.show{
    display: flex;
  }
  .spinning-cog{
    z-index:999;
    -webkit-transition: opacity ease 200ms;
    -moz-transition: opacity ease 200ms;
    -o-transition: opacity ease 200ms;
    transition: opacity ease 200ms;

    -webkit-animation: spinning-cog 2.5s infinite ease;
    -moz-animation: spinning-cog 2.5s infinite ease;
    -ms-animation: spinning-cog 2.5s infinite ease;
    -o-animation: spinning-cog 2.5s infinite ease;
    animation: spinning-cog 3s infinite ease;
  }
  @-webkit-keyframes spinning-cog {
    0% { transform: rotate(0deg) }
    30% { transform: rotate(-45deg) }
    60% { transform: rotate(360deg) }
    100% { transform: rotate(360deg) }
  }

  @-moz-keyframes spinning-cog {
    0% { transform: rotate(0deg) }
    30% { transform: rotate(-45deg) }
    60% { transform: rotate(360deg) }
    100% { transform: rotate(360deg) }
  }

  @-o-keyframes spinning-cog {
    0% { transform: rotate(0deg) }
    30% { transform: rotate(-45deg) }
    60% { transform: rotate(360deg) }
    100% { transform: rotate(360deg) }
  }

  @keyframes spinning-cog {
    0% { transform: rotate(0deg) }
    30% { transform: rotate(-45deg) }
    60% { transform: rotate(360deg) }
    100% { transform: rotate(360deg) }
  }
  #pattern_div{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index:99;
    background: #002855;
    /*background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIUlEQVQYV2NkQAL///83ZoTxwRxGxrNgARgHxGZE5oAEAOz3DzUR5jnxAAAAAElFTkSuQmCC);*/
    /*background-repeat: repeat;*/
    -webkit-transition: opacity ease 1s;
    -moz-transition: opacity ease 1s;
    -o-transition: opacity ease 1s;
    transition: opacity ease 1s;
    opacity: 1;
    display: none;
  }
  #page_progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    overflow: hidden;
    z-index:999;
    -webkit-transition: opacity ease 1s;
    -moz-transition: opacity ease 1s;
    -o-transition: opacity ease 1s;
    transition: opacity ease 1s;
    opacity: 1;
    display: none;
  }
  #progress_bar {
    position: absolute;
    top: 0;
    right: 100vw;
    width: 100%;
    height: 10px;
    overflow: hidden;
    z-index:999;
    background: #2AD2C9;

    -webkit-transition: all ease-out 700ms;
    -moz-transition: all ease-out 700ms;
    -o-transition: all ease-out 700ms;
    transition: all ease-out 700ms;
  }
  #full-page-loading #pattern_div, #full-page-loading #page_progress{
    display: block;
  }
  #full-page-loading #loading-text{
    color: #ffffff;
    font-size: 50px;
    margin-bottom: 30px;
  }
  @media (max-width: 480px) {
    #full-page-loading #loading-text{
      font-size: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// loading.vue?61aab63b